<template>
  <section class="create-server">
    <!--头部开始-->
    <v-login-info></v-login-info>
    <!--头部结束-->

    <!--表单内容开始-->
    <div class="create-server-content">
      <h3 class="create-server-title">创建服务器</h3>

      <form action="javascript: void(0)">
        <!--服务器名字-->
        <dl class="form-item clearfix">
          <dt class="item-title">服务器名字：</dt>
          <dd class="item-content">
            <input class="form-input server-name" name="serverName" type="text" v-model="formDatas.severName" v-validate="'required|min:2|max:7'">
          </dd>
        </dl>

        <!--游戏模式-->
        <dl class="form-item clearfix">
          <dt class="item-title">游戏模式：</dt>
          <dd class="item-content">
            <div class="radio-item">
              <span class="base-radio-box">
                <input id="pve" name="serverType" class="base-radio" type="radio" value="false" v-model="formDatas.rootType" v-validate="'required'" />
                <label class="icon-box" for="pve">
                  <i class="icon icon-radio-unchecked"></i>
                </label>
              </span>
              <span>和平房间模式</span>
            </div>

            <div class="radio-item">
              <span class="base-radio-box">
                <input id="pvp" name="serverType" class="base-radio" type="radio" value="true" v-model="formDatas.rootType" v-validate="'required'" />
                <label class="icon-box" for="pvp">
                  <i class="icon icon-radio-unchecked"></i>
                </label>
              </span>
              <span class="text">混战房间模式</span>
            </div>
          </dd>
        </dl>

        <!--密码设置-->
        <dl class="form-item clearfix">
          <dt class="item-title">密码设置：</dt>
          <dd class="item-content">
            <div class="radio-item">
              <span class="base-radio-box">
                <input id="noPwd" name="pwd" class="base-radio" type="radio" value="false" v-model="formDatas.serverIsPwd" v-validate="'required'" />
                <label class="icon-box" for="noPwd">
                  <i class="icon icon-radio-unchecked"></i>
                </label>
              </span>
              <span class="text">无密码</span>
            </div>

            <div class="radio-item">
              <span class="base-radio-box">
                <input id="hasPwd" name="pwd" class="base-radio" type="radio" value="true" v-model="formDatas.serverIsPwd" v-validate="'required'" />
                <label class="icon-box" for="hasPwd">
                  <i class="icon icon-radio-unchecked"></i>
                </label>
              </span>

              <span class="text">有密码</span>

              <span>
                <input class="server-pwd" type="password" v-model="formDatas.serverPwd"/>
              </span>
            </div>
          </dd>
        </dl>

        <!--房间列表-->
        <dl class="form-item clearfix">
          <dt class="item-title">公开房间列表:</dt>
          <dd class="item-content">
            <div class="radio-item radio-inline">
              <span class="base-radio-box">
                <input id="pub" name="rootList" class="base-radio" type="radio" value="true" v-model="formDatas.serverIsPublic" v-validate="'required'" />
                <label class="icon-box" for="pub">
                  <i class="icon icon-radio-unchecked"></i>
                </label>
              </span>
              <span class="text">公开</span>
            </div>

            <div class="radio-item radio-inline">
              <span class="base-radio-box">
                <input id="noPub" name="rootList" class="base-radio" type="radio" value="false" v-model="formDatas.serverIsPublic" v-validate="'required'" />
                <label class="icon-box" for="noPub">
                  <i class="icon icon-radio-unchecked"></i>
                </label>
              </span>
              <span class="text">不公开</span>
            </div>
          </dd>
        </dl>

        <!--服务器套餐-->
        <dl class="form-item server-type clearfix">
          <dt class="item-title">服务器套餐：</dt>

          <dd class="item-content">
            <div class="radio-item radio-inline">
              <span class="base-radio-box">
                <input id="small" name="serverPackage" class="base-radio" type="radio" value="1" v-model="formDatas.serverType" v-validate="'required'" />
                <label class="icon-box" for="small">
                  <i class="icon icon-radio-unchecked"></i>
                </label>
              </span>
              <span class="text">小型服</span>
            </div>

            <div class="radio-item radio-inline">
              <span class="base-radio-box">
                <input id="middle" name="serverPackage" class="base-radio" type="radio" value="2" v-model="formDatas.serverType" v-validate="'required'" />
                <label class="icon-box" for="middle">
                  <i class="icon icon-radio-unchecked"></i>
                </label>
              </span>
              <span class="text">中型服</span>
            </div>

            <p class="ticket-desc">小型服务器最多可同时在线12人，中型服务器可同时在线50人。</p>

            <div class="ticket-count">
              <span>小型开服券 {{ countTicket(1).length }}</span>
              <span>中型开服券 {{ countTicket(2).length }}</span>
            </div>
          </dd>
        </dl>

        <p class="error-tips">{{ formErrot }}</p>

        <!--创建按钮-->
        <div class="handle">
          <a class="btn" href="javascript: void(0)" @click="createServerFn">创建 </a>
        </div>
      </form>
    </div>
    <!--表单内容结束-->

    <!--使用提示层-->
    <v-basic-mask :show="tipsShow" @closeMaskEv="closeMaskEvFn">
      <span slot="desc">{{ tipsText }}</span>
    </v-basic-mask>
  </section>
</template>

<script type='text/ecmascript-6'>
  // 用户登录信息组件
  import loginInfo from 'components/loginInfo/loginInfo'
  // ajax 请求插件
  import Axios from 'axios'
  // 引入 cookie插件
  import VueCookie from 'vue-cookie'
  // 用户信息相关操作
  import {delUserCookie} from 'assets/js/user'
  // 基础弹出层组件
  import basicMask from 'components/basicMask/basicMask'
  const ERROR_TIPS = [
    { desc: '网络错误' },
    { desc: '表单验证失败' },
    { desc: '开服卷数量不足' }
  ]
  export default {
    // 创建服务器
    name: 'createServer',
    data () {
      return {
        // 表单验证错误信息
        formErrot: '',
        // 开服卷服务器列表
        ticketServerList: [],
        // 提示层开关
        tipsShow: false,
        // 提示信息
        tipsText: '',
        // 表单数据
        formDatas: {
          // 用户id
          userId: VueCookie.get('UserID'),
          // session id
          sessionId: VueCookie.get('SessionID'),
          // 服务器名称
          severName: '',
          // 选择的开服卷id
          selectTicketId: '',
          // 选择的开服卷类型
          selectTicketType: '',
          // 是否创建密码
          serverIsPwd: '',
          // 服务器密码
          serverPwd: '',
          // 是否公开服务器
          serverIsPublic: '',
          // 服务器模式
          serverType: '',
          // 房间模式
          rootType: ''
        }
      }
    },
    created () {
      // 初始化页面信息
      this.init()
    },
    methods: {
      init () {
        // 实例化表单对象
        let formData = new FormData()
        // 将用户名添加到表单
        formData.append('userId', this.formDatas.userId)
        // 将session id表单
        formData.append('sessionId', this.formDatas.sessionId)

        // 请求是否创建过游戏服务器 api
        Axios.post(`${this.$api.root}/PersonalRoom/GetHaveGameServer`, formData, {
          // 设置请求为表单提交
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then((response) => {
          // http 请求成功
          if (response.status === 200) {
            // 获取接口数据
            let res = response.data
            switch (res.Code) {
              case 0:
                // 创建过私服
                if (res.HaveGameServer) {
                  // 跳转到首页
                  this.$router.push({name: 'home'})
                // 请求开服卷信息接口
                } else {
                  // 请求开服卷 api
                  Axios.post(`${this.$api.root}/PersonalRoom/GetTicketInfo`, formData, {
                    // 设置请求为表单提交
                    headers: {
                      'Content-Type': 'application/x-www-form-urlencoded'
                    }
                  }).then((response) => {
                    // http 请求成功
                    if (response.status === 200) {
                      // 获取接口数据
                      let res = response.data
                      // 开服卷服务器列表
                      this.ticketServerList = res.TicketList
                    }
                  }).catch((error) => {
                    console.log(error)
                  })
                }
                break
              case 1:
                // 删除用户信息
                delUserCookie()
                // 跳转到登录页
                this.$router.push({name: 'login'})
                break
              case 2:
                this.tipsShow = true
                this.tipsText = res.Msg
                break
              default:
                this.tipsShow = true
                this.tipsText = res.Msg
            }
          }
        }).catch((error) => {
          console.log(error)
        })
      },
      // 创建服务器
      createServerFn () {
        // 验证表单所有信息
        this.$validator.validateAll().then(() => {
          // 表单有错误返回 true 没错误返回 false
          // console.log(this.errors.any())
          // 返回所有错信的信息列表
          // console.log(this.errors.all())
          // 表单是否有错误信息
          let isError = this.errors.any()
          // 有错误信息
          if (isError) {
            // console.log(this.errors.all())
            // console.log(this.errors.first('serverName'))
            // console.log(this.$validator.errors.all())
            // console.log(this.$validator.errors.all())
            // console.log(this.$validator.errors.first('serverName'))
            // 获取所有错误信息的数组列表
            let formErrors = this.$validator.errors.all()
            // 返回第一个错误信息
            this.formErrot = formErrors[0]
          } else {
            // 清空表单错误提示信息
            this.formErrot = ''
            // 获取选择的开服卷的数量
            let titckArr = this.countTicket(this.formDatas.serverType)
            // 如果数量大于0，开始创建服务器
            if (titckArr.length > 0) {
              this.formDatas.selectTicketId = titckArr[0].TicketId
              // 实例化表单对象
              let formData = new FormData()
              // 将用户名添加到表单
              formData.append('userId', this.formDatas.userId)
              // session id
              formData.append('sessionId', this.formDatas.sessionId)
              // 服务器名称
              formData.append('ServerName', this.formDatas.severName)
              // 服务器类型
              formData.append('CheckPvpType', this.formDatas.rootType)
              // 选择的开服卷类型
              formData.append('TicketType', this.formDatas.serverType)
              // 是否公开房间列表
              formData.append('CheckPublic', this.formDatas.serverIsPublic)
              // 服务器是否创建密码
              formData.append('CheckPassWord', this.formDatas.serverIsPwd)
              // 选择的开服卷 id
              formData.append('TicketId', this.formDatas.selectTicketId)
              // 是否创建密码
              if (this.formDatas.serverIsPwd) {
                formData.append('Password', this.formDatas.serverPwd)
              }

              /*
              console.log('用户id = ' + this.formDatas.userId)
              console.log('session = ' + this.formDatas.sessionId)
              console.log('服务器名称 = ' + this.formDatas.severName)
              console.log('游戏模式 = ' + this.formDatas.rootType)
              console.log('服务器类型 = ' + this.formDatas.serverType)
              console.log('开服卷id = ' + this.formDatas.selectTicketId)
              console.log('是否有密码 = ' + this.formDatas.serverIsPwd)
              console.log('服务器设置密码 = ' + this.formDatas.serverPwd)
              console.log('服务器是否公开 = ' + this.formDatas.serverIsPublic)
              */

              // 请求登录 api
              Axios.post(`${this.$api.root}/PersonalRoom/CreateGameServer`, formData, {
                // 设置请求为表单提交
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
                }
              }).then((response) => {
                // http 请求成功
                if (response.status === 200) {
                  console.log(response)
                  // 获取接口数据
                  let res = response.data
                  switch (res.Code) {
                    case 0:
                      this.$router.push({name: 'serverManage'})
                      break
                    case 1:
                      // 删除用户信息
                      delUserCookie()
                      // 跳转到登录页
                      this.$router.push({name: 'login'})
                      break
                    case 2:
                      this.tipsShow = true
                      this.tipsText = res.Msg
                      break
                    default:
                      this.tipsShow = true
                      this.tipsText = res.Msg
                  }
                  if (res.Code === 0) {
                    this.$router.push({name: 'serverManage'})
                  }
                }
              }).catch((error) => {
                console.log(error)
              })
            } else {
              this.tipsShow = true
              this.tipsText = ERROR_TIPS[2].desc
            }
          }
        }).catch(() => {
          this.tipsShow = true
          this.tipsText = ERROR_TIPS[0].desc
        })
      },
      // 开服卷统计
      countTicket (type) {
        // 初始化列表
        let list = []
        this.ticketServerList.forEach((item) => {
          // 将于选择类型一致的服务器数据添加到列表
          if (parseInt(item.TicketType) === parseInt(type)) {
            list.push(item)
          }
        })
        // 返回列表
        return list
      },
      // 关闭提示层
      closeMaskEvFn (val) {
        // 关闭弹出层
        this.tipsShow = val
        // 是否刷新页面
        if (this.refreshFlag) {
          // 重置刷新标志
          this.refreshFlag = false
          // 刷新页面
          this.$router.go(0)
        }
      }
    },
    components: {
      'v-login-info': loginInfo,
      'v-basic-mask': basicMask
    }
  }
</script>

<style lang='stylus' rel='stylesheet/stylus'>
  @import 'createServer.styl';
  @import '../../assets/stylus/checkbox.styl';
  @import '../../assets/stylus/radio.styl';
</style>



// WEBPACK FOOTER //
// src/views/createServer/createServer.vue